export default __webpack_public_path__ + "static/media/mondologo-world.1ddf73fe.png";